import officeImage from "../../Assets/Images/why_us.png";
import SectionHeading from "./SectionHeading";

const WhyUsDetail = () => {
  return (
    <section className="why-us  ">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-6 mb-4 mb-lg-0 text-center pb-4">
            <div className="why-img">
              <img src={officeImage} alt="Office" />
            </div>
            <div className="decorative-border"></div>
          </div>

          <div className="col-lg-6">
            <div className="fw-light lh-base why-content">
              <p>
                We believe in delivering exceptional experiences that go beyond
                expectations. With five back-to-back successful events and
                participation in 20+ prestigious gatherings, we have established
                a track record of excellence in a remarkably short span. In just
                two years, we have built a strong network of professionals,
                experts, and public figures, ensuring seamless coordination and
                top-notch execution. Our deep collaborations with renowned
                vendors, premium venues, and industry leaders guarantee
                high-quality services tailored to your needs. From concept to
                completion, we handle every aspect of your event with precision
                and professionalism, ensuring a flawless experience.
              </p>
              <p>
                What sets us apart is our passion-driven approach, where
                creativity, innovation, and dedication come together to craft
                extraordinary events.
                <br />
                When you choose us, you choose excellence, reliability, and a
                commitment to making your event truly unforgettable.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
function WhyUs() {
  return (
    <div>
      <SectionHeading
        secTitle="WHY US"
        secIndex="Proven Success – With 5 back-to-back successful events and participation in 20+ prestigious gatherings, we deliver excellence."
      />
      <WhyUsDetail />
    </div>
  );
}
export default WhyUs;
